import React from 'react'
import { parseDate } from './util/dates'

interface Update {
    date: string
    updates: {
        type: string
        short_desc: string | JSX.Element
    }[]
}

export const updates: Update[] = [
    {
        date: '2022-03-10',
        updates: [
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue causing Promotion Logs to create empty log items in certain circumstances',
            },
        ],
    },
    {
        date: '2022-03-09',
        updates: [
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue with currency conversion in the totals of the Profiles Overview table',
            },
            {
                type: 'feature',
                short_desc: 'Released the change log',
            },
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue where occassionally totals in the Profiles Overview page were not ' +
                    'correctly using the converted currency values',
            },
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue with the integration with the third party we use for currency conversion rates',
            },
            {
                type: 'update',
                short_desc: 'Added feature request form',
            },
            {
                type: 'update',
                short_desc: 'Added uploaded instructions for Quick Create',
            },
        ],
    },
    {
        date: '2022-03-08',
        updates: [
            {
                type: 'bugfix',
                short_desc:
                    'fixed another type conversion issue causing some bulk actions and recipes to fail',
            },
        ],
    },
    {
        date: '2022-03-07',
        updates: [
            {
                type: 'update',
                short_desc:
                    'Adds tooltip to Product Overview pages to show clickable links to all campaigns, active' +
                    ' campaigns, all ad groups, or all active ad groups on hover.',
            },
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue in the date range selector where it would incorrectly show a selected preset date range.',
            },
            {
                type: 'feature',
                short_desc: (
                    <>
                        Added recipe scheduling! You can now run recipes:
                        <ul className="ml-4 list-disc">
                            <li>
                                on certain days of the week (ie every Monday, Wednesday, and Friday)
                            </li>
                            <li>just once a date in the future (ie on September 20th)</li>
                            <li>every other week on a certain day (ie every 2 weeks on Friday)</li>
                            <li>every month on a certain date (ie every month on the 1st)</li>
                            <li>every quarter on a certain date (ie every 3 months on the 1st)</li>
                            <li>
                                every year on a certain date (ie every year on the September 1st)
                            </li>
                        </ul>
                    </>
                ),
            },
            {
                type: 'bugfix',
                short_desc:
                    'Fixed a verbiage issue in audit logs when Smart Bids was trying to increase the bid, but the bid was\n' +
                    '                    decreased due to a maximum bid decrease.',
            },
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue causing the incorrect number of active ad groups to show up in the Product Overview page',
            },
        ],
    },
    {
        date: '2022-03-04',
        updates: [
            {
                type: 'bugfix',
                short_desc:
                    'Fixed a type conversion issue causing some bulk actions and recipes to fail',
            },
        ],
    },
    {
        date: '2022-03-03',
        updates: [
            {
                type: 'feature',
                short_desc: 'Major overhaul to bulk actions!',
            },
        ],
    },
    {
        date: '2022-03-01',
        updates: [
            {
                type: 'update',
                short_desc: 'Adds SKU based quick create for Seller Central users',
            },
        ],
    },
    {
        date: '2022-02-28',
        updates: [
            {
                type: 'update',
                short_desc: 'Performance patch in Filter logic',
            },
            {
                type: 'feature',
                short_desc: 'Adds support for multi asin quick-creates!',
            },
        ],
    },
    {
        date: '2022-02-24',
        updates: [
            {
                type: 'update',
                short_desc:
                    'Adds [Deleted] tag to Audit Logs when viewing log data from a deleted promotion',
            },
            {
                type: 'update',
                short_desc: 'Added ability to right click on a column header to hide column',
            },
            {
                type: 'update',
                short_desc: 'Added ability to create or link a quick create item to a portfolio',
            },
        ],
    },
    {
        date: '2022-02-20',
        updates: [
            {
                type: 'update',
                short_desc: 'Added profile toggling to the table area in the Profile Overview page',
            },
        ],
    },
    {
        date: '2022-02-18',
        updates: [
            {
                type: 'bugfix',
                short_desc: 'Fixed an issue causing certain API endpoints intermittently',
            },
        ],
    },
    {
        date: '2022-02-17',
        updates: [
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue where unhandled errors would interrupt service for one of the services',
            },
        ],
    },
    {
        date: '2022-02-16',
        updates: [
            {
                type: 'update',
                short_desc:
                    'Adds ability to load all advertised asins in to Product Overview table',
            },
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue where navigation menu didn’t vertically scroll in some circumstances.',
            },
        ],
    },
    {
        date: '2022-02-15',
        updates: [
            {
                type: 'update',
                short_desc:
                    'Added number of active promo rules, total promo rules, number of active promos, and ' +
                    'total number of promos to Product Overview page',
            },
        ],
    },
    {
        date: '2022-02-13',
        updates: [
            {
                type: 'update',
                short_desc: 'Added ability to filter by smart bid source type in audit logs',
            },
            {
                type: 'update',
                short_desc:
                    'Tweaked query related to historical event data to increase performance ~10.',
            },
        ],
    },
    {
        date: '2022-02-11',
        updates: [
            {
                type: 'update',
                short_desc:
                    'Added negative search term indicator for existing negative search terms in the Search ' +
                    'Terms page when adding negative keywords',
            },
            {
                type: 'update',
                short_desc: 'Added promotion last run time',
            },
        ],
    },
    {
        date: '2022-02-10',
        updates: [
            {
                type: 'update',
                short_desc: 'Added ability to toggle profiles from pie chart in Profile Overview',
            },
            {
                type: 'update',
                short_desc: 'Added ability to open filter menu by clicking a filter tag',
            },
        ],
    },
    {
        date: '2022-02-08',
        updates: [
            {
                type: 'bugfix',
                short_desc: 'Fixed another issue preventing some promotions from opening.',
            },
            {
                type: 'feature',
                short_desc: 'Added bid recommendations beta feature.',
            },
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue causing certainly deeply nested recipe triggers to not be processed correctly',
            },
        ],
    },
    {
        date: '2022-02-07',
        updates: [
            {
                type: 'bugfix',
                short_desc: 'Fixed an issue preventing some promotions from opening.',
            },
            {
                type: 'update',
                short_desc: 'Added the number of ad groups used in a promotion rule',
            },
        ],
    },
    {
        date: '2022-02-03',
        updates: [
            {
                type: 'update',
                short_desc: 'Added currency conversion support in Profiles Overview page',
            },
        ],
    },
    {
        date: '2022-02-02',
        updates: [
            {
                type: 'update',
                short_desc:
                    'Added number of active campaigns and active ad groups to product overview',
            },
            {
                type: 'feature',
                short_desc: 'Added Profile Overview page',
            },
        ],
    },
    {
        date: '2022-01-31',
        updates: [
            {
                type: 'feature',
                short_desc: 'Added quick create feature',
            },
        ],
    },
    {
        date: '2022-01-27',
        updates: [
            {
                type: 'update',
                short_desc: 'Saves per page setting and removes it from the URL',
            },
            {
                type: 'update',
                short_desc: 'Saves “Advanced Search setting when creating promotions',
            },
            {
                type: 'bugfix',
                short_desc: 'Fixed an issue when exporting data from placements table',
            },
            {
                type: 'update',
                short_desc: 'Added ability to filter by target type in Targets page',
            },
        ],
    },
    {
        date: '2022-01-23',
        updates: [
            {
                type: 'feature',
                short_desc: 'New feature! Product Overview table',
            },
        ],
    },
    {
        date: '2022-01-21',
        updates: [
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue in the keyword recommendation that was allowing invalid asins through',
            },
        ],
    },
    {
        date: '2022-01-20',
        updates: [
            {
                type: 'bugfix',
                short_desc: 'Fixed an issue causing bulk actions and recipes to occasionally lock.',
            },
        ],
    },
    {
        date: '2022-01-19',
        updates: [
            {
                type: 'update',
                short_desc:
                    'Added ability to filter by portfolio in Campaigns, Ad Groups, Placements, Keywords, ' +
                    'Targets, Negative Targets, Negative Keywords, Campaign Negative Keywords, and Product Ads tables.',
            },
        ],
    },
    {
        date: '2022-01-18',
        updates: [
            {
                type: 'feature',
                short_desc: 'Added Portfolios table',
            },
        ],
    },
    {
        date: '2022-01-17',
        updates: [
            {
                type: 'feature',
                short_desc: 'Adds new rounding strategies',
            },
            {
                type: 'feature',
                short_desc: 'Adds keyword recommendations beta page',
            },
        ],
    },
    {
        date: '2022-01-15',
        updates: [
            {
                type: 'update',
                short_desc:
                    'Added “effectively enabled”, “effectively running”, “effectively active”, and' +
                    ' “effectively paused”, and “effectively archived” states to Recipes',
            },
        ],
    },
    {
        date: '2022-01-14',
        updates: [
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue in the underlying framework that was causing some recipes ' +
                    'and promotions to not be run when they should be.',
            },
        ],
    },
    {
        date: '2022-01-13',
        updates: [
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue causing interruptions in part of a data cleanup process',
            },
        ],
    },
    {
        date: '2022-01-11',
        updates: [
            {
                type: 'update',
                short_desc: 'Added various performance improvements across the ad tables.',
            },
            {
                type: 'update',
                short_desc:
                    'Adds ability to select all promotion rules, adds sorting across all promotion' +
                    ' table items, adds created at times to promotion table.',
            },
            {
                type: 'update',
                short_desc: 'Various UI enhancements to promotions.',
            },
        ],
    },
    {
        date: '2022-01-09',
        updates: [
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an issue in the ingestion pipeline causing syncs to run slower than expected',
            },
        ],
    },
    {
        date: '2022-01-06',
        updates: [
            {
                type: 'bugfix',
                short_desc:
                    'Fixed an intermittent issue on Smart Bids that would prevent a bid update from going through',
            },
        ],
    },
    {
        date: '2022-01-05',
        updates: [
            {
                type: 'update',
                short_desc: 'Migrates Smart Bids from Logs to Audit Logs',
            },
        ],
    },
    {
        date: '2022-01-04',
        updates: [
            {
                type: 'update',
                short_desc: 'Rolled out affiliate program!',
            },
            {
                type: 'update',
                short_desc: 'Various UI enhancements to promotions.',
            },
        ],
    },
]

export const summaries = [
    {
        title: 'March Updates',
        date: '2022-03-31',
        updates_filter: (updates: Update[]) =>
            updates.filter((i) => {
                const date = parseDate(i.date)
                return date.getFullYear() === 2022 && date.getMonth() === 2 // 0 based month
            }),
        description: (
            <>
                <div className="mb-3">
                    March has been focused on shoring up the ability for bulk actions and recipes to
                    run on a huge number of ads at once. We have completely rewritten the underlying
                    logic for both bulk actions and recipes to allow them to run on 500k+ items at
                    once. In addition to that, we've introduced better error logs when a bulk action
                    or recipe fails.
                </div>
                <div>
                    In other news:
                    <ul className="list-disc ml-4">
                        <li>
                            Added the ability to schedule recipes to run on certain days or certain
                            dates, making it easy to run your "once a week" or "once a month"
                            optimizations.
                        </li>
                        <li>The change log was released!</li>
                    </ul>
                </div>
            </>
        ),
    },
    {
        title: 'February Updates',
        date: '2022-02-28',
        updates_filter: (updates: Update[]) =>
            updates.filter((i) => {
                const date = parseDate(i.date)
                return date.getFullYear() === 2022 && date.getMonth() === 1 // 0 based month
            }),
        description: (
            <>
                <div className="mb-3">
                    A majority of February was dedicated to improving the ability to navigate and
                    quickly analyze your ad performance. This includes the new Profile Overview
                    page, allowing you to see an overview of all your profiles on a single table, in
                    whatever currency you wish. As well as a number of other UI improvements to make
                    it easier to navigate and find the data you are looking for.
                </div>
                <div>
                    The gems from this month:
                    <ul className="list-disc ml-4">
                        <li>The new Profile Overview page!</li>
                        <li>
                            The new Bid Recommendation beta feature, allowing you to see suggested
                            bids for your ads, as well as your search term impression share across
                            all of Amazon.
                        </li>
                        <li>
                            Quick create now supports the ability to create multiple single-asin
                            campaigns at once
                        </li>
                    </ul>
                </div>
            </>
        ),
    },
    {
        title: 'January Updates',
        date: '2022-01-31',
        updates_filter: (updates: Update[]) =>
            updates.filter((i) => {
                const date = parseDate(i.date)
                return date.getFullYear() === 2022 && date.getMonth() === 0 // 0 based month
            }),
        description: (
            <>
                <div className="mb-3">
                    January was focused on adding more new features to make creating and optimizing
                    your ads faster than ever!
                </div>
                <div>
                    A few highlights:
                    <ul className="list-disc ml-4">
                        <li>
                            We rolled out an early beta version of our Quick Create feature,
                            allowing you to easily create single ASIN campaigns in just a few
                            clicks.
                        </li>
                        <li>New beta features! Product Overview table,</li>
                        <li>Improved stability to bulk actions and recipe runs</li>
                    </ul>
                </div>
            </>
        ),
    },
]
